// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__30lTP","header":"MessagesList_header__sThxJ","chat":"MessagesList_chat__1TUzQ"};